module.exports = __webpack_public_path__ + "static/media/allImpact_60y_n-1.4eb631d6.csv";